// extracted by mini-css-extract-plugin
export var container = "_69-0";
export var error = "_69-9";
export var label = "_69-5";
export var light = "_69-6";
export var md = "_69-3";
export var sm = "_69-2";
export var thin = "_69-8";
export var thinBold = "_69-7";
export var vertical = "_69-4";
export var xs = "_69-1";